import { DomSanitizer } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';
import DOMPurify from 'dompurify';

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    const sanitizedContent = DOMPurify?.sanitize(value);
    return this.sanitized.bypassSecurityTrustHtml(sanitizedContent);

  }
}
